import React, { Component } from 'react';
import { Route, Switch } from 'react-router'
import MainLayout from './components/MainLayout';
import { EmptyLayout } from './components/EmptyLayout';
import { Home } from './components/Home';
import { NoValidLicense } from './components/NoValidLicense';
import { NoTenantRegistration } from './components/NoTenantRegistration';
import { Large } from './components/Large';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={props => (
    <Layout>
      <Component {...props} />
    </Layout>
  )} />
)

export default class App extends Component {
  displayName = App.name

  render() {

    return (
      <div>

                    <Switch>
                        <AppRoute exact path="/" layout={ MainLayout } component={ Home } />
                        <AppRoute path='/novalidlicense' layout={ MainLayout } component={NoValidLicense} />
                        <AppRoute path='/notenantregistration' layout={ MainLayout } component={NoTenantRegistration} />
                        <AppRoute path="/large" layout={ EmptyLayout } component={ Large } />
                    </Switch>
 
      </div>
    );
  }
}

